import React from "react";
import styles from "./Icons.module.css";
import yarn from "../assets/yarn-black.svg";
import hook from "../assets/logo/ganchillo.svg";

function Icons({ text, icon, style, flex, user, href }) {
  return (
    <p style={flex} className={styles.text}>
      <span className={styles.icon} style={style}>
        {icon}
      </span>
      <p className={styles.fontsmall}>{text}</p>
      <a className={styles.link} href={href}>
        {user}
      </a>
    </p>
  );
}

function SocialIcons({ href, icon }) {
  return (
    <a href={href} className={styles.social}>
      {icon}
    </a>
  );
}

function IconYarn({ flex, text, style }) {
  return (
    <p style={flex} className={styles.text}>
      <img src={yarn} alt="yarn" className={styles.svg} style={style}></img>
      <p className={styles.fontsmall}>{text}</p>
    </p>
  );
}

function IconHook({ flex, text, style }) {
  return (
    <p style={flex} className={styles.text}>
      <img src={hook} alt="hook" className={styles.svg} style={style}></img>
      {text}
    </p>
  );
}

export { Icons };
export { SocialIcons };
export { IconYarn };
export { IconHook };
